import React from "react";
import banner1 from "../../assets/banner 2.png";
import {
  FaTruck,
  FaGlobe,
  FaArrowsAltH,
  FaDollarSign,
  FaPercent,
  FaThumbsUp,
} from "react-icons/fa";

const features = [
  {
    id: 1,
    icon: <FaTruck className="text-[22px] text-white" />,
    title: "5 Day Production, Low Minimums",
    desc: "Our Fast option produces patches in five days — available for select patch types, including options with low minimums starting at just 10 patches.",
  },
  {
    id: 2,
    icon: <FaGlobe className="text-[22px] text-white" />,
    title: "High Quality Materials",
    desc: "Our patches feature premium threads and durable fabrics for sharp, vibrant designs that endure daily wear and washing.",
  },
  {
    id: 3,
    icon: <FaArrowsAltH className="text-[22px] text-white" />,
    title: "Versatile Attachment Options",
    desc: "We offer various backing options, including heat press, iron-on, peel-and-stick, and Velcro, to suit your application needs.",
  },
  {
    id: 4,
    icon: <FaDollarSign className="text-[22px] text-white" />,
    title: "No Setup or Art Fees",
    desc: "To keep our embroidered patches and other patch types affordable, there are no set up or art fees.",
  },
  {
    id: 5,
    icon: <FaPercent className="text-[22px] text-white" />,
    title: "Bulk Order Discounts",
    desc: "Save up to 74% on bulk orders — the more you buy, the more you save!",
  },
  {
    id: 6,
    icon: <FaThumbsUp className="text-[22px] text-white" />,
    title: "Satisfaction Guarantee",
    desc: "Report production errors within 45 days for a replacement or refund. No returns needed before approval.",
  },
];

const WhyBuySection = () => {
  return (
    <section className="w-full bg-gray-50 py-8 sm:py-10 lg:py-12">
      <div className="mx-auto w-full max-w-[1600px] space-y-6 px-4 sm:px-6 lg:px-10">
        {/* Section 1 */}
        <div className="w-full bg-white py-10 sm:py-12 lg:py-14">
          <div className="mx-auto w-full max-w-[1100px] px-4 sm:px-6 lg:px-10">
            <div className="rounded-[16px] border border-gray-200 bg-[#f8fafc] px-5 py-8 sm:px-8 lg:px-10">
              <h2 className="text-center text-3xl font-bold tracking-wide text-[#2b2b2b] md:text-4xl">
                Design Your Own Patch Online
              </h2>

              <p className="mt-5 text-[15px] leading-[26px] text-[#555] sm:text-[17px]">
                Our interactive platform makes it easy to design your own patch
                online without any technical skills.
              </p>

              <ul className="mt-6 space-y-3 text-[15px] leading-[25px] text-[#333] sm:text-[16px]">
                <li className="flex gap-3">
                  <span className="font-bold text-[#f97316]">•</span>
                  <span>	Select your patch shape (rect, circle, shield, etc)</span>
                </li>

                <li className="flex gap-3">
                  <span className="font-bold text-[#f97316]">•</span>
                  <span>	Insert your logo, text and artwork.</span>
                </li>

                <li className="flex gap-3">
                  <span className="font-bold text-[#f97316]">•</span>
                  <span>Pick colors, borders, and stitching style</span>
                </li>

                <li className="flex gap-3">
                  <span className="font-bold text-[#f97316]">•</span>
                  <span>Preview your patch in an instant</span>
                </li>

                <li className="flex gap-3">
                  <span className="font-bold text-[#f97316]">•</span>
                  <span>	Make your order and get it on right.</span>
                </li>

              
              </ul>

              <p className="mt-6 text-[15px] font-medium leading-[26px] text-[#555] sm:text-[16px]">
                Nor does it need any technical know-how - it only needs good ideas. And if you ever need guidance, our expert custom patch designers are here to assist every step of the way. Start Designing Now - Bring your vision to life with our professional Patch Designers USA near me service!
              </p>
            </div>
          </div>
        </div>

        <div className="h-px bg-gray-200"></div>

        {/* Section 2 */}
        <div className="w-full bg-[rgba(31,44,76,0.95)] py-10 sm:py-12 lg:py-14">
  <div className="mx-auto w-full max-w-[1600px] px-4 sm:px-6 lg:px-10">
    <div className="grid grid-cols-1 items-center gap-8 lg:grid-cols-[0.95fr_1.05fr] lg:gap-12">
      {/* CONTENT */}
      <div className="order-2 lg:order-1">
        <div className="mb-8 text-left sm:mb-10">
          <h2 className="text-xl font-bold leading-snug tracking-wide text-white sm:text-2xl md:text-3xl">
  USA-Wide Coverage & Personalized Wholesale Patch Designers USA
</h2>

          <div className="mt-6 h-px w-full max-w-[620px] bg-white/30"></div>
        </div>

        <p className="max-w-[780px] text-[15px] font-medium leading-[27px] text-white/90 sm:text-[16px] sm:leading-[28px]">
          Looking for patch designers USA wholesale pricing? We've got you covered.
          Patches required, one or thousands, we have:
        </p>

        <div className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-2">
          {[
            "Competitive wholesale facilities.",
            "Volume discounting on bulk purchase.",
            "Quick shipments across the USA.",
            "Quality that you can rely on always.",
          ].map((item, index) => (
            <div
              key={index}
              className="flex gap-3 rounded-[14px] border border-white/15 bg-white/10 px-4 py-4 transition-all duration-300 hover:-translate-y-1 hover:bg-white/15"
            >
              <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-[#fff7ed] text-[13px] font-extrabold text-[#f97316]">
                o
              </span>

              <p className="m-0 text-[14px] font-semibold leading-[23px] text-white/90 sm:text-[15px]">
                {item}
              </p>
            </div>
          ))}
        </div>

        <p className="mt-6 max-w-[780px] text-[15px] font-medium leading-[27px] text-white/85 sm:text-[16px] sm:leading-[28px]">
          Even if you initially searched for Patch Designers USA near me, you get
          local-level service with nationwide coverage. Whether it is a small batch
          or huge order, we provide the ideal quality/price ratio.
        </p>

        <div className="mt-6 max-w-[780px] rounded-[16px] border border-[#f97316]/30 bg-[#fff7ed] px-5 py-4 text-[#0a2336]">
         <p className="m-0 text-[15px] font-normal leading-[24px] text-[#4a4a4a] sm:text-[16px]">
  Place Your Tailor Made Patches today - wholesale and retail packages!
</p>
        </div>
      </div>

      {/* IMAGE */}
      <div className="order-1 lg:order-2">
        <div className="mx-auto w-full max-w-[720px] overflow-hidden rounded-[22px] border border-white/15 bg-white/10 p-3 shadow-[0_24px_60px_rgba(0,0,0,0.28)] sm:p-4">
          <img
            src={banner1}
            alt="USA-Wide Coverage & Personalized Wholesale Patch Designers USA"
            className="h-auto w-full rounded-[16px] object-cover"
          />
        </div>
      </div>
    </div>
  </div>
</div>

        <div className="h-px bg-gray-200"></div>

        {/* Section 3 */}
        <div className="w-full bg-white py-10 sm:py-12 lg:py-14">
          <div className="mx-auto w-full max-w-[1500px] px-4 sm:px-6 lg:px-10">
            <div className="mx-auto mb-8 max-w-[780px] text-center">
              <h2 className="text-center text-3xl font-bold tracking-wide text-[#2b2b2b] md:text-4xl">
                Our Process
              </h2>

              <div className="mx-auto mt-6 h-px w-full max-w-[620px] bg-[#9ca3af]"></div>

              <p className="mx-auto mt-5 max-w-[760px] text-[15px] font-medium leading-[26px] text-[#415164] sm:text-[16px]">
                Every patch is crafted with precision, vibrant colors, and
                long-lasting quality.
              </p>
            </div>

            <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5">
              {[
                { number: "01", title: "Consultation", text: "Share your idea" },
                { number: "02", title: "Draft Design", text: "Initial concept" },
                { number: "03", title: "Feedback", text: "Request changes" },
                { number: "04", title: "Production", text: "Quality materials" },
                { number: "05", title: "Delivery", text: "Fast shipping" },
              ].map((step) => (
                <div
                  key={step.number}
                  className="group relative flex min-h-[190px] flex-col items-center justify-start overflow-hidden rounded-[18px] border border-[#e8eef5] bg-[#f8fafc] px-3 py-7 text-center shadow-sm transition-all duration-300 hover:-translate-y-1 hover:border-[#f97316]/40 hover:bg-white hover:shadow-[0_16px_35px_rgba(15,23,42,0.12)] sm:px-4 xl:px-3 2xl:px-5"
                >
                  <div className="mx-auto mb-5 flex h-[58px] w-[58px] shrink-0 items-center justify-center rounded-full bg-[#0a2336] text-[18px] font-extrabold text-white transition-all duration-300 group-hover:bg-[#f97316]">
                    {step.number}
                  </div>

                  <h3 className="mb-2 whitespace-nowrap text-[14px] font-extrabold uppercase leading-[22px] text-[#0a2336] sm:text-[15px] lg:text-[14px] xl:text-[13px] 2xl:text-[16px]">
                    {step.title}
                  </h3>

                  <p className="text-[14px] font-medium leading-[22px] text-[#555] sm:text-[15px] xl:text-[14px] 2xl:text-[15px]">
                    {step.text}
                  </p>

                  <div className="absolute bottom-0 left-0 h-[4px] w-0 bg-[#f97316] transition-all duration-300 group-hover:w-full"></div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="h-px bg-gray-200"></div>


{/*New Section Add For Content */}
<div className="w-full bg-white py-10 sm:py-12 lg:py-14">
  <div className="mx-auto w-full max-w-[1600px] px-4 sm:px-6 lg:px-10">
    <div className="mb-8 text-center sm:mb-10">
      <h2 className="mx-auto max-w-[1050px] text-center text-3xl font-bold tracking-wide text-[#2b2b2b] md:text-4xl">
        Our Process - Personalized, Precise, Professional Custom Patch Designers
      </h2>
    </div>

    <div className="mx-auto max-w-[1180px] rounded-[24px] border border-[#e5eaf0] bg-[#f8fafc] p-5 shadow-[0_12px_35px_rgba(15,35,54,0.08)] sm:p-7 lg:p-8">
      <p className="text-[15px] font-medium leading-[27px] text-[#415164] sm:text-[16px] sm:leading-[28px]">
        Patches with us are easy and uncomplicated to make:
      </p>

      <div className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-5">
        {[
          "Consultation: Share your idea, message or concept.",
          "Draft Design: This involves drafting a design.",
          "Feedback: Ask for updates or improvements",
          "Design: Made of quality materials.",
          "Delivery: Rapid delivery in the USA.",
        ].map((item, index) => (
          <div
            key={index}
            className="flex gap-3 rounded-[14px] border border-[#e5eaf0] bg-white px-4 py-4 transition-all duration-300 hover:-translate-y-1 hover:border-[#f97316]/40 hover:shadow-[0_12px_28px_rgba(15,35,54,0.10)]"
          >
            <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-[#fff7ed] text-[13px] font-extrabold text-[#f97316]">
              o
            </span>

            <p className="m-0 text-[14px] font-semibold leading-[23px] text-[#415164]">
              {item}
            </p>
          </div>
        ))}
      </div>

      <p className="mt-6 text-[15px] font-medium leading-[27px] text-[#415164] sm:text-[16px] sm:leading-[28px]">
        All the patches contain an eye on detail, bright color, and long-term
        significance. That's why customers trust Patch Designers USA online for
        all their patch needs.
      </p>

      <div className="mt-6 rounded-[16px] border border-[#f97316]/20 bg-[#fff7ed] px-5 py-4">
       <p className="m-0 text-[15px] font-normal leading-[24px] text-[#4a4a4a] sm:text-[16px]">
  No guessing. No delays. Just quality that you can see and feel.
</p>
      </div>
    </div>
  </div>
</div>

        {/* CTA */}
        <div className="rounded-[20px] bg-gradient-to-b from-[#437d6a]/10 via-white to-white px-4 py-8 text-center sm:px-6 lg:px-10">
          <h2 className="text-center text-3xl font-bold tracking-wide text-[#2b2b2b] md:text-4xl">
            Start Designing Your Patch
          </h2>

          <p className="mx-auto mt-5 max-w-[760px] text-[15px] font-medium leading-[26px] text-[#415164] sm:text-[16px]">
            Bring your ideas to life with professional patch designers.
          </p>
        </div>

        {/* Features Section */}
        <div className="rounded-[24px] bg-gradient-to-br from-[#f8fafc] via-white to-[#fff7ed] px-4 py-10 shadow-[0_18px_50px_rgba(15,35,54,0.08)] sm:px-6 lg:px-10 lg:py-12">
          <div className="grid grid-cols-1 gap-5 md:grid-cols-2 xl:grid-cols-3">
            {features.map((item) => (
              <div
                key={item.id}
                className="group relative overflow-hidden rounded-[18px] border border-[#e5eaf0] bg-white p-5 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:border-[#f97316]/40 hover:shadow-[0_18px_40px_rgba(15,35,54,0.12)] sm:p-6"
              >
                <div className="mb-5 flex items-center gap-4">
                  <div className="flex h-[54px] w-[54px] shrink-0 items-center justify-center rounded-[16px] bg-[#0a2336] shadow-md transition-all duration-300 group-hover:bg-[#f97316]">
                    {item.icon}
                  </div>

                  <h4 className="text-[17px] font-extrabold leading-[23px] text-[#0a2336] sm:text-[18px]">
                    {item.title}
                  </h4>
                </div>

                <p className="text-[14px] font-medium leading-[24px] text-[#4b5563] sm:text-[15px]">
                  {item.desc}
                </p>

                <div className="absolute bottom-0 left-0 h-[4px] w-0 bg-[#f97316] transition-all duration-300 group-hover:w-full"></div>
              </div>
            ))}
          </div>
 
        </div>
      </div>
 {/*New Section Content */}

<div className="w-full bg-white py-10 sm:py-12 lg:py-14">
  <div className="mx-auto w-full max-w-[1600px] px-4 sm:px-6 lg:px-10">
    <div className="mb-8 text-center sm:mb-10">
      <h2 className="mx-auto max-w-[1050px] text-center text-3xl font-bold tracking-wide text-[#2b2b2b] md:text-4xl">
        Quality You Can See - Materials That Last Best Patch Designers USA
      </h2>
    </div>

    <div className="mx-auto max-w-[1180px] rounded-[24px] border border-[#e5eaf0] bg-[#f8fafc] p-5 shadow-[0_12px_35px_rgba(15,35,54,0.08)] sm:p-7 lg:p-8">
      <p className="text-[15px] font-medium leading-[27px] text-[#415164] sm:text-[16px] sm:leading-[28px]">
        Our patches are not just a simple appearance but they are created to work.
        We employ good quality of threads, strong backings, and quality
        embroideries process such that your patches:
      </p>

      <div className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
        {[
          "Remain lively even after continuous use.",
          "Resist fraying and wear",
          "appear peppy on jackets, shirts, bags and gear.",
          "Be formative and detailed with time.",
        ].map((item, index) => (
          <div
            key={index}
            className="flex gap-3 rounded-[14px] border border-[#e5eaf0] bg-white px-4 py-4 transition-all duration-300 hover:-translate-y-1 hover:border-[#f97316]/40 hover:shadow-[0_12px_28px_rgba(15,35,54,0.10)]"
          >
            <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-[#fff7ed] text-[13px] font-extrabold text-[#f97316]">
              o
            </span>

            <p className="m-0 text-[14px] font-semibold leading-[23px] text-[#415164]">
              {item}
            </p>
          </div>
        ))}
      </div>

      <p className="mt-6 text-[15px] font-medium leading-[27px] text-[#415164] sm:text-[16px] sm:leading-[28px]">
        Our designs make an impression in terms of branding, fashion, identity or
        personal style.
      </p>

      <div className="mt-6 rounded-[16px] border border-[#f97316]/20 bg-[#fff7ed] px-5 py-4">
       <p className="m-0 text-[15px] font-normal leading-[24px] text-[#4a4a4a] sm:text-[16px]">
  Customize Now - Make a patch that lasts with custom patch designers USA
  expertise.
</p>
      </div>
    </div>
  </div>
</div>


    </section>
  );
};

export default WhyBuySection;